// // by https://markus.oberlehner.net/blog/make-your-vuex-state-flat-state-normalization-with-vuex/
//
// export function normalizeRelations(data, fields) {
//   return {
//     ...data,
//     ...fields.reduce(
//       (prev, field) => ({
//         ...prev,
//         [field]: Array.isArray(data[field])
//           ? data[field].map(x => x.id)
//           : data[field].id
//       }),
//       {}
//     )
//   };
// }
//
// export function resolveRelations(data, fields, rootGetters) {
//   return {
//     ...data,
//     ...fields.reduce(
//       (prev, field) => ({
//         ...prev,
//         [field]: Array.isArray(data[field])
//           ? data[field].map(x => rootGetters[`${field}/find`](x))
//           : rootGetters[`${field}/find`](data[field])
//       }),
//       {}
//     )
//   };
// }
import { normalize as rNormalize, schema } from "normalizr";

export const User = new schema.Entity("user");

export const Project = new schema.Entity("project", {
  owner: User,
  allowed_userlist: [User]
});

export const ImagingStudy = new schema.Entity("imagingStudy");

export const AnnotationClass = new schema.Entity("annotationClass");

export const WSIStatus = new schema.Entity("wsiStatus", {
  annotation_class: AnnotationClass
});

export const Slide = new schema.Entity("slide", {
  project: Project,
  imagingStudy: ImagingStudy,
  wholeslideimagestatus_set: [WSIStatus],
  annotation_class: [AnnotationClass]
});

export const Annotation = new schema.Entity("annotation", {
  annotation_class: AnnotationClass
});

export const Diagnosis = new schema.Entity("diagnosis", undefined, {
  idAttribute: value => value.name
});

export const ReportDiagnosis = new schema.Entity("reportDiagnosis");

export const ReportTileGrid = new schema.Entity("reportTileGrid");

export const ReportWSI = new schema.Entity("reportWSI", {
  ReportTileGrid: ReportTileGrid,
  ReportDiagnosis: ReportDiagnosis
});

export const ReportBatch = new schema.Entity("reportBatch", {
  reportWSIs: [ReportWSI]
});

export function normalize(data, schema) {
  return rNormalize(data, schema);
}
// export function denormalize(data, schema) {
//   return rNormalize(data, schema);
// }
